import { render, staticRenderFns } from "./list.vue?vue&type=template&id=50c4e98c&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=50c4e98c&prod&lang=scss"
import style1 from "./list.vue?vue&type=style&index=1&id=50c4e98c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c4e98c",
  null
  
)

export default component.exports